<template>
    <div v-if="showSlider" class="pgapp-segment">
        <div @click="slidePrev" class="ion-slide-nav ion-slide-nav-left" :class="{'visible': showLeftButton}">
            <svg class="icon icon-chevron-left">
                <use xlink:href="#icon-chevron-left"></use>
            </svg>
        </div>
        <ion-slides ref="slides"
                    @ionSlideDidChange="slideChanged"
                    :options="responsiveSliderOptions"
                    mode="md">
            <ion-slide v-for="(item,index) in categories" @click="filterData(item.slug)" :key="index" style="width: auto !important">
                <ion-segment-button mode="md" :data-active="category == item.slug ? true : false">
                    <ion-label>{{ item.name }}</ion-label>
                </ion-segment-button>
            </ion-slide>
        </ion-slides>
        <div @click="slideNext" class="ion-slide-nav ion-slide-nav-right" :class="{'visible': showRightButton}">
            <svg class="icon icon-chevron-right">
                <use xlink:href="#icon-chevron-right"></use>
            </svg>
        </div>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import { mapState } from 'vuex';

    export default {
        name: 'NewsSegment',
        computed: {
            ...mapState({
                loading: state => state.news.loading,
                categories: state => state.global.categories.news,
                category: state => state.news.category
            }),

            showSlider(){
                return this.categories.length > 0 ? true : false
            },

            showLeftButton(){
                return this.sliderIndex != 0 ? true : false
            },

            showRightButton(){
                return !this.sliderEnd ? true : false
            },

            categorySliderIndex(){
                return this.showSlider ? this.categories.findIndex(item => item.slug == this.category) : null
            },

            sliderCurrentSlug(){
                return this.showSlider ? this.categories[this.categorySliderIndex].slug : null
            },

            sliderFirstVisibleSlug(){
                return this.showSlider ? this.categories[this.sliderIndex].slug : null
            },

            responsiveSliderOptions(){
                if(this.windowWidth <= 330){
                    return { slidesPerView: 1 }
                }
                if(this.windowWidth <= 380){
                    return { slidesPerView: 2 }
                }
                if(this.windowWidth <= 480){
                    return { slidesPerView: 3 }
                }
                if(this.windowWidth <= 580){
                    return { slidesPerView: 4 }
                }
                if(this.windowWidth > 580){
                    return { slidesPerView: 5 }
                }
                return 1
            }
        },
        data(){
            return {
                // helpers
                windowWidth: window.innerWidth,
                sliderIndex: 0,
                sliderLength: 0,
                sliderEnd: false,
            }
        },
        watch: {
            // update slider options after vuex categories are set
            showSlider(){
                this.fixSliderOptions()
            },
            // fetch news on category change
            sliderCurrentSlug(category){
                this.$store.dispatch('news/KNOWLEDGE_NEWS_SET_CATEGORY', category);
            },
        },
        created(){
            // 1-news, 2-trainings, 3-advertisements, 4-places, 5-wikis, 6-products
            // no longer needed - fetched by pages
            // this.$store.dispatch('GLOBAL_CATEGORIES_REQUEST', 1)

            window.addEventListener("resize", this.windowResize);
        },
        mounted(){
            this.fixSliderOptions()
            // slide to current category name
            setTimeout(() => {
                this.slideTo()
            }, 300)
        },
        methods: {
            filterData(category){
                this.$store.dispatch('news/KNOWLEDGE_NEWS_SET_CATEGORY', category);
            },
            slideChanged(){
                // update slider helpers
                this.$refs.slides.getActiveIndex().then(index => {
                    this.sliderIndex = index
                })
                this.$refs.slides.length().then(length => {
                    this.sliderLength = length
                })
                this.$refs.slides.isEnd().then(bool => {
                    this.sliderEnd = bool
                })
            },
            slideNext(){
                this.$refs.slides.slideNext();
            },
            slidePrev(){
                this.$refs.slides.slidePrev();
            },
            slideTo(){
                if(!this.$refs.slides) return
                this.$refs.slides.slideTo(this.categorySliderIndex);
            },
            fixSliderOptions() {
                this.$nextTick(() => {
                    if(!this.$refs.slides) return
                    this.$refs.slides.options = this.responsiveSliderOptions;
                });
            },
            windowResize(e) {
                this.windowWidth = window.innerWidth
                this.fixSliderOptions()
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.windowResize);
        },
    }
</script>